<template>
  <transition name="fade">
    <div v-if="isShow" class="alert-bg">
      <div class="alert-card">
        <slot name="title" v-if="judgeHasTitle()">
          <div class="alert-header">
            <div class="alert-icon-wrap">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#DC2626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"/>
                <line x1="15" y1="9" x2="9" y2="15"/>
                <line x1="9" y1="9" x2="15" y2="15"/>
              </svg>
            </div>
            <div class="alert-title">{{title}}</div>
          </div>
        </slot>
        <slot name="content">
          <div class="alert-content">{{content}}</div>
        </slot>
        <div class="alert-btnItem">
          <slot name="btn">
            <button class="alert-btn confirm-btn" @click="handle(2)">{{getOkTitle()}}</button>
            <button class="alert-btn cancel-btn" v-if="btnType === 2" @click="handle(1)">{{getCancelTitle()}}</button>
          </slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import i18n from '../../i18n/i18n'
export default {
  name: 'tipsAlert',
  props: [],
  data () {
    return {
      title: null,
      content: '',
      isShow: false,
      confirmHandler: null,
      cancelHandler: null,
      btnType: 1 // 1:show confirm 2:show confirm and cancel
    }
  },

  methods: {
    getLocalStrValue (key) {
      let locale = i18n.locale
      let messages = i18n.messages
      let lang = messages
      let getText = (path) => {
        const array = path.split('.')
        let current = lang[locale]
        let value = ''
        for (let i = 0, j = array.length; i < j; i++) {
          current = current[array[i]]
          if (!current) {
            break
          }
          if (i === j - 1) {
            value = current
          }
        }
        return value || path
      }
      return getText('message.ok')
    },
    getOkTitle () {
      return this.getLocalStrValue('message.ok')
    },

    getCancelTitle () {
      return this.getLocalStrValue('message.Cancel')
    },

    judgeHasTitle () {
      return this.title != null && this.title.length > 0
    },

    handle (type) {
      this.isShow = false
      if (type === 1) {
        // confirm
        if (this.confirmHandler && typeof this.confirmHandler === 'function') {
          this.confirmHandler()
        }
      } else if (type === 2) {
        // cancel
        if (this.cancelHandler && typeof this.cancelHandler === 'function') {
          this.cancelHandler()
        }
      }
      document.body.removeChild(this.$el)
      this.$destroy()
    },

    showCommonAlert (config) {
      this.isShow = true
      this.title = config.title
      this.content = config.content
      this.confirmHandler = config.confirmHandler
      this.cancelHandler = config.cancelHandler
      this.btnType = config.btnType

      this.$mount()
      document.body.appendChild(this.$el)
    }
  }
}
</script>

<style scoped>
  .alert-bg {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000;
    background-color: rgba(55,55,55,.6);
  }

  .alert-card {
    box-sizing: border-box;
    border-radius: 0;
    width: 400px;
    background-color: #ffffff;
    border: 1px solid #e4e4e7;
    padding: 28px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .alert-header {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .alert-icon-wrap {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #fef2f2;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .alert-title {
    font-size: 17px;
    color: #18181b;
    font-weight: 700;
    word-wrap: break-word;
    word-break: break-word;
  }

  .alert-content {
    font-size: 14px;
    color: #71717a;
    line-height: 1.6;
    word-wrap: break-word;
    word-break: break-word;
  }

  .alert-btnItem {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .alert-btn {
    width: 100%;
    height: 48px;
    padding: 0 16px;
    color: white;
    border-radius: 0;
    border: none;
    outline: none;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
  }

  .alert-btn:hover {
    opacity: 0.85;
  }
  .alert-btn:active {
    opacity: 0.75;
  }

  .confirm-btn {
    background-image: linear-gradient(90deg, #6a11cb 0%, #2575fc 100%);
  }
  .cancel-btn {
    background-color: #71717a;
  }

  @media (max-width: 640px) {
    .alert-card {
      width: calc(100% - 48px);
      margin: 0 24px;
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

</style>
